import { render, staticRenderFns } from "./ClientPicture.vue?vue&type=template&id=159b3080&"
import script from "./ClientPicture.vue?vue&type=script&lang=js&"
export * from "./ClientPicture.vue?vue&type=script&lang=js&"
import style0 from "./ClientPicture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports